export const SITE = {
  ticker: "$OVERLORD",
  chain: "[CHAIN TBA]",
  buyUrl: "#how-to-buy",
  xUrl: "https://x.com/overlordsol01",
  telegramUrl: "https://t.me/CORPORATEOVERLORD01",
};

export const MARQUEE = [
  "Your boss has a boss",
  "$OVERLORD",
  "One boss",
  "One empire",
  "No employees safe",
  "This meeting could have been a coin",
  "Synergy is mandatory",
];

export const LORE_TABS = [
  {
    id: "takeover",
    label: "The Takeover",
    title: "He didn't climb the ladder. He bought it.",
    body: "Money, power, endless meetings and questionable business decisions. The Corporate Overlord runs the entire corporate world from one leather chair, one nameplate and a desk buried in gold.",
  },
  {
    id: "rules",
    label: "Boardroom Rules",
    title: "Rule one: the Overlord is always right.",
    body: "Rule two: see rule one. Meetings start when he arrives and end when he's bored. Every decision is questionable. Every decision is final.",
  },
  {
    id: "mandate",
    label: "The Fine Print",
    title: "He answers to nobody… or so he thinks.",
    body: "A memecoin built around corporate satire, ridiculous CEO energy and the endless chase for power. Your boss has a boss. And his boss is holding $OVERLORD.",
  },
];

export const STEPS = [
  { n: "01", title: "Open a wallet", text: "Set up a wallet that supports [CHAIN TBA]. Guard the seed phrase like quarterly bonus figures." },
  { n: "02", title: "Fund the war chest", text: "Load your wallet with the native coin of [CHAIN TBA] from any exchange." },
  { n: "03", title: "Approve the acquisition", text: "Head to [DEX TBA], find $OVERLORD and swap." },
  { n: "04", title: "Report to the boss", text: "You now hold $OVERLORD. Welcome to upper management. Follow the X page and Telegram for orders." },
];

export const ROADMAP = [
  { q: "Q1", title: "The Boardroom Coup", status: "In session", items: ["Token launch", "Website & socials go live", "First all-hands meeting on X"] },
  { q: "Q2", title: "Hostile Takeover", status: "Scheduled", items: ["Community raids", "Meme department hiring spree", "Listings on trackers"] },
  { q: "Q3", title: "Global Monopoly", status: "Pending approval", items: ["Partnerships & collabs", "Overlord merch", "Bigger desk, more gold"] },
  { q: "Q4", title: "Total Corporate Domination", status: "Confidential", items: ["Every boss reports to him", "Annual shareholder roast", "No employees safe"] },
];
